/**
 * Route paths for the stock and yards module.
 * Single source of truth — reuse these instead of hard-coding `/yards...` or `/MoveStock` strings.
 */
export const STOCK_ROUTES = {
  root: "/yards",
  details: "/yards/:id",
  moveStock: "/MoveStock",
} as const;

export const columnHeaders = [
  { field: "sl", headerName: "Sl No", flex: 0.5 },
  { field: "yardName", headerName: "Name", flex: 2 },
  { field: "yardLocation", headerName: "Location", flex: 2 },
];

export const stockHistoryColumnHeaders = [
  { field: "sl", headerName: "Sl No", flex: 0.5 },
  { field: "itemName", headerName: "Item Name", flex: 2 },
  { field: "count", headerName: "Count", flex: 2 },
];

export const yards = [
  {
    id: 1,
    yardName: "Production Yard",
    yardLocation: "Bangalore",
  },
  {
    id: 2,
    yardName: "Procurement Yard",
    yardLocation: "Chennai",
  },
  {
    id: 3,
    yardName: "Stock Yard",
    yardLocation: "Coimbatore",
  },
];

export const stockItems = [
  {
    id: 1,
    itemName: "Cement",
    count: 100,
  },
  {
    id: 2,
    itemName: "Steel",
    count: 500,
  },
  {
    id: 3,
    itemName: "AAC Blocks",
    count: 2000,
  },
];

export const moveStockItemsColumns = [
  { field: "sl", headerName: "Sl No", flex: 0.7 },
  { field: "name", headerName: "Item Name", flex: 1 },
  { field: "price", headerName: "Price", flex: 1 },
  { field: "quantity", headerName: "Quantity", flex: 1 },
  { field: "total", headerName: "Total", flex: 1 },
];
